import { faqData } from '@/mocks/home-data';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3 justify-center">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            常见问答
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 text-center">
          关于爆料吃瓜平台的常见问题解答
        </p>

        <div className="space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q:</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}